/* SABERA: 慣性スクロール (Lenis 1.3.25)
   lenis.min.js を読み込んだ後に defer で実行される。

   ■ なぜ Lenis を選べるか (このテーマとの相性)
   Lenis は wrapper を transform でずらすのではなく、毎フレーム実際の
   スクロール位置を動かす。そのため以下がそのまま生き残る:
     - CSS scroll-driven animation (view-timeline)
       parallax-hero / product-showcase / product-hero / product-detail-block
     - position: fixed の背景画像 (parallax-hero)
     - position: sticky (product-showcase のカード)
     - scroll イベントに依存する JS (sabera-header の隠す/出す)

   ■ 無効化する条件
   - prefers-reduced-motion: reduce — 慣性は「動きを減らす」設定と相反する
   - テーマエディタ (Shopify.designMode) — セクション選択時の自動スクロールと
     競合して位置がずれるため素のスクロールに任せる
   - lenis.min.js の読み込み失敗 — 何もしなければ素のスクロールのまま

   ■ タッチは OS 標準に任せる (syncTouch: false)
   iOS/Android の慣性は OS 側の方が自然で、無理に上書きすると
   アドレスバーの開閉やプルトゥリフレッシュと噛み合わなくなる。 */
(() => {
  if (typeof window.Lenis !== 'function') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;

  const lenis = new window.Lenis({
    // 減衰係数。小さいほど「重く」長く滑る。0.1 で約 0.3 秒で収束する程度
    lerp: 0.1,
    smoothWheel: true,
    // タッチは OS 標準の慣性に任せる
    syncTouch: false,
    // ページ内アンカー (#foo) を Lenis 側で滑らかに処理させる
    anchors: true,
    // 内部で requestAnimationFrame ループを回す
    autoRaf: true,
  });

  // 他のスクリプトから停止/再開できるように公開する
  // (モーダルやドロワーを開いている間に lenis.stop() したい場合など)
  window.lenis = lenis;
})();
